import React from 'react'
import {
  Spin,
  Input,
  Tabs,
  Button,
  DatePicker,
  Divider,
  Select,
  Modal,
  Upload,
} from 'antd'
import common from '@/public/common'
import { ajaxApi } from '@/server/index'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { uploadErrHandle, getParmUrl,tokenConfig } from '@/public/utils'
import _lodash from 'lodash'
import {PlusOutlined, UploadOutlined} from '@ant-design/icons'
const { TabPane } = Tabs
const { Option } = Select
const { TextArea } = Input
// 接口文档：http://confluence.vsigo.cn/pages/viewpage.action?pageId=62757811
// 产品文档：https://lanhuapp.com/web/#/item/project/product?tid=1ca58a0c-b5db-495e-9266-4c1939691356&teamId=1ca58a0c-b5db-495e-9266-4c1939691356&pid=8326a26b-daf3-470f-ab32-b2d371c211e4&project_id=8326a26b-daf3-470f-ab32-b2d371c211e4&image_id=2b9e0946-7798-4e29-9309-0c1a5dded272&docId=2b9e0946-7798-4e29-9309-0c1a5dded272&docType=axure&pageId=bf4b71426f704863b9ade90315f895b8&parentId=4c668fd069df4e8a8faddccf196845f2&type=share_board&pwd=LA5K&activeSectionId=&userId=ca140a70-5418-46eb-a57b-a09dc97335f7&versionId=adb226c1-2f8b-48f2-b4b2-ad2609520b42
class CorrespondingManufacturerGoods extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      paramData: {
        'item_id': null,
        'vender_id': null,
        'qua_category': ''
      },
      AgentData: [],
      testUrl: window.location.host.split('t').length - 1 === 1
    }
  }

  componentDidMount () {
    let {paramData} = this.state
    paramData.item_id = getParmUrl('itemId') * 1 ? getParmUrl('itemId') * 1 : null
    paramData.vender_id = getParmUrl('venderId') * 1 ? getParmUrl('venderId') * 1 : null
    paramData.qua_category = getParmUrl('quaCategory')
    this.setState({
      paramData
    }, () => {
      this.getAgentData()
    })
  }

    // 获取商品对应的厂商资质
    getAgentData=async () => {
      let {paramData, testUrl} = this.state
      this.setState({
        loading: true
      })
      try {
        let res = await ajaxApi({
          url: common.scpUrl + 'item/query-item-supplier-qua',
          params: paramData
        })
        this.setState({
          loading: false
        })
        if (res.status === 200) {
          if (res.data) {
            if (res.data.data.length !== 0) {
              let _data = res.data.data
              _data.map((item, index) => {
                if (item.qua_value.length !== 0) {
                  item.qua_value.map((item2, index2) => {
                    if (item2.length !== 0) {
                      item2.map((item3, index3) => {
                        if (item3.qua_filed_type === 'Picture') {
                          let _imageList = []
                          item3.qua_filed_value.map((item4, index4) => {
                            _imageList.push({
                              uid: 0 - index4.toString(),
                              name: 'image.png',
                              response: { url: item4 },
                              status: 'done',
                              url:common.imageUrl+'po/qua/image/'+ item4
                            })
                          })
                          item3.imgList = _imageList
                        } else if (item3.qua_filed_type === 'File') {
                          let _fileList = []
                          item3.qua_filed_value.map((item4, index4) => {
                            _fileList.push({
                              uid: index4.toString(),
                              name: item4,
                              response: { url: item4 },
                              status: 'done',
                              url:common.imageUrl+'po/qua/file/'+  item4
                            })
                          })
                          item3.fileListNew = _fileList
                        }
                      })
                    }
                  })
                }
              })
              this.setState({
                AgentData: _data
              })
            } else {
              this.setState({
                AgentData: []
              })
            }
          }
        } else {
          this.setState({
            AgentData: []
          })
        }
      } catch (e) {
        this.setState({
          loading: false
        })
        console.log(e)
      }
    }

  // 获取输入框的值
  handleChangeInput = (e, index, index2, index3) => {
    let { AgentData, testUrl, editData, postData } = this.state
    AgentData[index].qua_value[index2][index3].qua_filed_value =
      e.target.value
    this.setState(
      {
        AgentData
      }
    )
  };

  // 获取下拉框的值
  handelSelect=(e, index, index2, index3) => {
    let { AgentData, testUrl, editData, postData } = this.state
    AgentData[index].qua_value[index2][index3].qua_filed_value = e

    this.setState(
      {
        AgentData
      }
    )
  }

  // 获取时间的值
  handleChangeDate = (e, index, index2, index3) => {
    let { AgentData, testUrl, editData, postData } = this.state
    AgentData[index].qua_value[index2][index3].qua_filed_value = e
      ? moment(e).valueOf()
      : null

    this.setState(
      {
        AgentData
      }
    )
  };

  // 图片上传
  handleChangeResponsibility = (index, index2, index3, { file, fileList }) => {
    let { AgentData, testUrl, editData, postData } = this.state
    fileList = uploadErrHandle(file, fileList)

    if (file.status === 'done') {
      fileList = fileList.map((item, index) => {
        // 相关文件对象数据格式化处理
        return item
      })
    }
    AgentData[index].qua_value[index2][index3].imgList = fileList
    AgentData[index].qua_value[index2][index3].imgList.map((item) => {
      if (item.response) {
        item.url = common.imageUrl+'po/qua/image/' + item.response.url
        AgentData[index].qua_value[index2][
          index3
        ].qua_filed_value.push(item.response.url)
        AgentData[index].qua_value[index2][
          index3
        ].qua_filed_value = _lodash.uniqWith(
          AgentData[index].qua_value[index2][index3].qua_filed_value,
          _lodash.isEqual
        )
      }
    })

    // 避免原来的文件丢失，这样子写就可以了
    this.setState(
      {
        AgentData,
        editData
      }
    )
  };

  // 删除图片
  handleDeleteImg = (index, index2, index3, file) => {
    let { AgentData, testUrl, editData, postData } = this.state
    let _url = file.response.url
    AgentData[index].qua_value[index2][index3].qua_filed_value.map(
      (item, i) => {
        if (item === _url) {
          AgentData[index].qua_value[index2][
            index3
          ].qua_filed_value.splice(i, 1)
        }
      }
    )
    this.setState(
      {
        AgentData,
        editData
      }
    )
  };

  // 文件上传
  handleChangeFileAuthorize = (index, index2, index3, { file, fileList }) => {
    let { AgentData, testUrl, editData, postData } = this.state

    // let fileList = [...info.fileList]
    // 1. 限制上载的文件数
    // 只显示两个最近上传的文件，旧文件将被新文件替换
    // fileList = fileList.slice(-2)
    // 2. 从响应读取并显示文件链接
    if (file.status === 'done') {
      fileList = fileList.map((item, index) => {
        // 相关文件对象数据格式化处理
        return item
      })
    }

    AgentData[index].qua_value[index2][index3].fileListNew = uploadErrHandle(file, fileList)
    AgentData[index].qua_value[index2][index3].fileListNew.map(
      (item) => {
        let _urlCode = []
        if (item.response) {
          item.url =common.imageUrl+'po/qua/file/' + item.response.url
          _urlCode.push(item.response.url)
          AgentData[index].qua_value[index2][
            index3
          ].qua_filed_value.push(item.response.url)
          AgentData[index].qua_value[index2][
            index3
          ].qua_filed_value = _lodash.uniqWith(
            AgentData[index].qua_value[index2][index3].qua_filed_value,
            _lodash.isEqual
          )
        }
      }
    )

    this.setState(
      {
        AgentData,
        editData
      }
    )
  };

  // 删除文件
  handleDeleteFile = (index, index2, index3, file) => {
    let { AgentData, testUrl, editData, postData } = this.state
    let _url = file.response.url
    AgentData[index].qua_value[index2][index3].qua_filed_value.map(
      (item, i) => {
        if (item === _url) {
          AgentData[index].qua_value[index2][
            index3
          ].qua_filed_value.splice(i, 1)
        }
      }
    )
    this.setState(
      {
        AgentData
      }
    )
  };
  render () {
    let {AgentData} = this.state
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">上传</div>
      </div>
    )
    return (
      <div>
        <Spin spinning={this.state.loading}>
          <h2>
            <span style={{ fontSize: '16px' }}>质量管理 /监管类别/商品对应的厂商资质</span>
          </h2>
          <Divider />
          {AgentData
            ? AgentData.map((item, index) => {
              return (
                <div>
                  {item.qua_value
                    ? item.qua_value.map((item2, index2) => {
                      let _item2 = _lodash.filter(item2, (value) => {
                        return (
                          value !== null &&
                                  value.qua_filed_name === '资质名称'
                        )
                      })
                      let _item2New = _lodash.filter(item2, (value) => {
                        return (
                          value !== null &&
                                  value.qua_filed_name !== '资质名称'
                        )
                      })
                      return (
                        <div
                          key={index2}
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            border: '1px solid lavender',
                            marginBottom: '24px',
                            padding: '16px 16px'
                          }}
                        >
                          <div
                            style={{
                              width: '49%',
                              marginBottom: '16px',
                              lineHeight: '24px'
                            }}
                          >
                            <span
                              style={{
                                display: 'inline-block',
                                textAlign: 'right',
                                width: '112px',
                                float: 'left'
                              }}
                            >
                              <span style={{ color: 'red' }}>*</span>
                                      资质名称：
                            </span>
                            <span
                              style={{
                                fontSize: '24px',
                                fontWeight: 700,
                                lineHeight: '24px',
                                marginRight: '2%'
                              }}
                            >
                              {_item2[0].qua_filed_value}
                            </span>{' '}

                          </div>
                          {_item2New
                            ? _item2New.map((item3, index3) => {
                              return (
                                <div
                                  key={index3}
                                  style={{
                                    width: '49%',
                                    marginBottom: '16px'
                                  }}
                                >
                                  <div>
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        textAlign: 'right',
                                        width: '112px',
                                        float: 'left'
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: 'red',
                                          display:
                                                      item3.is_need === 1
                                                        ? 'inline-block'
                                                        : 'none'
                                        }}
                                      >
                                                  *
                                      </span>
                                      {item3.qua_filed_name + '：'}
                                    </span>
                                    {item3.qua_filed_type ===
                                              'Text' ? (
                                        <span>
                                          {' '}
                                          <Input
                                            placeholder="请输入"
                                            value={
                                              item3.qua_filed_value
                                                ? item3.qua_filed_value
                                                : ''
                                            }
                                            onChange={(e) =>
                                              this.handleChangeInput(
                                                e,
                                                index,
                                                index2,
                                                index3
                                              )
                                            }
                                            style={{
                                              width: 272,
                                              marginRight: '8px'
                                            }}
                                          />
                                        </span>
                                      ) : item3.qua_filed_type ===
                                                'Date' ? (
                                          <DatePicker
                                            onOpenChange={
                                              this.handleOpenChange
                                            }
                                            format="YYYY-MM-DD"
                                            style={{ width: '272px' }}
                                            onPanelChange={
                                              this.handlePanelChange
                                            }
                                            onChange={(e) =>
                                              this.handleChangeDate(
                                                e,
                                                index,
                                                index2,
                                                index3
                                              )
                                            }
                                            value={
                                              item3.qua_filed_value
                                                ? moment(
                                                  item3.qua_filed_value *
                                                            1
                                                )
                                                : null
                                            }
                                          />
                                        ) : item3.qua_filed_type ===
                                                'Picture' ? (
                                            <span
                                              style={{
                                                display: 'inline-block',
                                                width: '79%'
                                              }}
                                            >
                                              <Upload
                                                action = {common.scpUrl + 'item/upload-image'}
                                                headers={{...tokenConfig}}
                                                listType="picture-card"
                                                accept="image/jpeg,image/jpg,image/png"
                                                fileList={item3.imgList ? item3.imgList : []}
                                                onPreview={
                                                  this
                                                    .handlePreviewResponsibility
                                                }
                                                onChange={(e) => {
                                                  this.handleChangeResponsibility(
                                                    index,
                                                    index2,
                                                    index3,
                                                    e
                                                  )
                                                }}
                                                onRemove={(e) =>
                                                  this.handleDeleteImg(
                                                    index,
                                                    index2,
                                                    index3,
                                                    e
                                                  )
                                                }
                                              >
                                                {item3.imgList ? item3.imgList.length >= 8
                                                  ? null
                                                  : uploadButton : uploadButton}
                                              </Upload>
                                              <Modal
                                                visible={false}
                                                footer={null}
                                                onCancel={this.handleCancel}
                                              >
                                                <img
                                                  alt="example"
                                                  style={{ width: '100%' }}
                                                  src={''}
                                                />
                                              </Modal>
                                            </span>
                                          ) : item3.qua_filed_type ===
                                                'File' ? (
                                              <span>
                                                <Upload
                                                  action= {common.scpUrl + 'item/upload-image'}
                                                  headers={{...tokenConfig}}
                                                  accept=".pdf"
                                                  onChange={(e) =>
                                                    this.handleChangeFileAuthorize(
                                                      index,
                                                      index2,
                                                      index3,
                                                      e
                                                    )
                                                  }
                                                  onRemove={(e) =>
                                                    this.handleDeleteFile(
                                                      index,
                                                      index2,
                                                      index3,
                                                      e
                                                    )
                                                  }
                                                  fileList={item3.fileListNew ? item3.fileListNew : []}
                                                >
                                                  <Button>
                                                    <UploadOutlined />
                                                      上传文件
                                                  </Button>
                                                  <span
                                                    style={{
                                                      display: 'inline-block',
                                                      marginLeft: '8px',
                                                      color: '#cccccc'
                                                    }}
                                                  >
                                                      仅支持扩展名：.pdf
                                                  </span>
                                                </Upload>
                                              </span>
                                            ) : item3.qua_filed_type ===
                                              'Select' ? (
                                                <span>
                                                  <Select
                                                    showSearch
                                                    // mode="multiple"
                                                    style={{ width: 272, marginRight: '8px' }}
                                                    optionFilterProp="children"
                                                    placeholder="请选择"
                                                    value={item3.qua_filed_value}
                                                    onChange={(e) => this.handelSelect(e, index, index2, index3)}
                                                  >
                                                    <Option
                                                      key={0}
                                                      value='0'
                                                    >
                                                否
                                                    </Option>
                                                    <Option
                                                      key={1}
                                                      value='1'
                                                    >
                                                            是
                                                    </Option>
                                                  </Select>
                                                </span>
                                              ) : null}
                                  </div>
                                </div>
                              )
                            })
                            : null}
                        </div>
                      )
                    })
                    : null}
                </div>
              )
            })
            : null}
        </Spin>
      </div>

    )
  }
}
export default CorrespondingManufacturerGoods



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commodityqualification/corresponding-manufacturer-goods.js